import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import { Link, useLocation } from "react-router-dom";
// import ReactSlider from "react-slider";
import { CartContext } from "../context/CartContext";
import { toast } from "react-toastify";
import axios from "axios";

const ShopSection = () => {
  const { addToCart } = useContext(CartContext);
  let [grid, setGrid] = useState(false);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const observer = useRef();
  const isFetchingRef = useRef(false);

  const [activeFilterGroup, setActiveFilterGroup] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [brands, setBrands] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [totalProducts, setTotalProducts] = useState(0);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [categorySearch, setCategorySearch] = useState("");
  const [searchedCategories, setSearchedCategories] = useState([]);
  const [isSearchingCategory, setIsSearchingCategory] = useState(false);

  const [brandSearch, setBrandSearch] = useState("");
  const [searchedBrands, setSearchedBrands] = useState([]);
  const [isSearchingBrand, setIsSearchingBrand] = useState(false);

  const [showPriceRequestModal, setShowPriceRequestModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [product, setProduct] = useState(null);

  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get("search");

  const fetchSearchProducts = async (query, pageNum = 1) => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://udemandme.com/api/products/product/search?name=${encodeURIComponent(
          query,
        )}&page=${pageNum}&limit=20`,
      );

      const data = await res.json();

      if (data.success) {
        if (pageNum === 1) {
          setProducts(data.products);
        } else {
          setProducts((prev) => [...prev, ...data.products]);
        }

        // search usually has fewer pages
        setPages(data.pages || 1);
        setPage(pageNum);
      }
    } catch (err) {
      console.error("Search fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchQuery && searchQuery.length >= 3) {
      fetchSearchProducts(searchQuery, 1);
    } else {
      fetchProducts(1);
    }
  }, [searchQuery]);

  // Brand Handler
  useEffect(() => {
    fetch("https://udemandme.com/api/brand")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setBrands(data.data);
        }
      })
      .catch(console.error);
  }, []);

  // brand search
  useEffect(() => {
    const query = brandSearch.trim();

    if (!query) {
      setIsSearchingBrand(false);
      setSearchedBrands([]);
      return;
    }

    setIsSearchingBrand(true);

    const controller = new AbortController();

    const searchBrands = async () => {
      try {
        const res = await fetch(
          `https://udemandme.com/api/brand/search?name=${encodeURIComponent(query)}`,
          { signal: controller.signal },
        );

        const data = await res.json();

        if (data.success) {
          setSearchedBrands(data.data);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Brand search error:", err);
        }
      }
    };

    searchBrands();

    return () => controller.abort();
  }, [brandSearch]);

  //category sarc
  useEffect(() => {
    const query = categorySearch.trim();

    if (!query) {
      setIsSearchingCategory(false);
      setSearchedCategories([]);
      return;
    }

    setIsSearchingCategory(true);

    const controller = new AbortController();

    const searchCategories = async () => {
      try {
        const res = await fetch(
          `https://udemandme.com/api/categories/search?name=${encodeURIComponent(query)}`,
          { signal: controller.signal },
        );

        const data = await res.json();

        if (data.success) {
          setSearchedCategories(data.data);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Category search error:", err);
        }
      }
    };

    searchCategories();

    return () => controller.abort();
  }, [categorySearch]);

  //REPLACE your current useEffect for fetching categories
  const fetchCategories = async () => {
    try {
      setCategoryLoading(true);

      const res = await fetch("https://udemandme.com/api/categories/all");
      const data = await res.json();

      if (data.success) {
        setCategories(data.data); // 🔥 ALL categories at once
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    } finally {
      setCategoryLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Observer to trigger category lazy load
  const categoryObserver = useRef();

  //   for managing letter case by frontend
  const formatCategoryName = (name) => {
    return name
      .toLowerCase()
      .split(/[\s-]/) // split by space or hyphen
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "); // join back with space
  };
  const [attributes, setAttributes] = useState([]);

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const res = await fetch("https://udemandme.com/api/attributes");
        const data = await res.json();
        if (data.success) {
          setAttributes(data.data);
        }
      } catch (err) {
        console.error("Error fetching attributes:", err);
      }
    };
    fetchAttributes();
  }, [page]);

  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };
  const displayName = (name) => {
    switch (name) {
      case "Shoe Size Required":
        return "Shoe Size"; // shorten it
      default:
        return name; // fallback to original
    }
  };

  const fetchProducts = async (pageNum) => {
    setLoading(true);
    try {
      const limit = 40;

      const res = await fetch(
        `https://udemandme.com/api/products/filter?page=${pageNum}&limit=20&category=WELDING+MACHINE`,
      );
      const data = await res.json();

      if (data.success) {
        // 🔑 normalize backend → frontend contract
        const formattedProducts = data.products.map((product) => ({
          ...product,
          // 🔴 CHANGED HERE ↓↓↓
          productCategories: product.productCategories || [],
          // 🔴 PREVIOUSLY: product.categories || []
        }));

        if (pageNum === 1) {
          setProducts(formattedProducts);
        } else {
          setProducts((prev) => [...prev, ...formattedProducts]);
        }

        const correctPages = Math.ceil((data.total || 0) / limit);
        setPages(correctPages);
        setPage(pageNum);
        setTotalProducts(data.total || 0);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchQuery) {
      fetchProducts(1);
    }
  }, [searchQuery]);

  const [sortOption, setSortOption] = useState("default");
  const [originalProducts, setOriginalProducts] = useState([]);

  const handleSort = (e) => {
    const value = e.target.value;
    setSortOption(value);

    let sortedProducts = [...products];

    if (value === "low") {
      sortedProducts.sort(
        (a, b) =>
          (a.productSalePriceInr || a.productRegularPriceInr) -
          (b.productSalePriceInr || b.productRegularPriceInr),
      );
    } else if (value === "high") {
      sortedProducts.sort(
        (a, b) =>
          (b.productSalePriceInr || b.productRegularPriceInr) -
          (a.productSalePriceInr || a.productRegularPriceInr),
      );
    } else {
      // default case → reset karo
      sortedProducts = [...originalProducts];
    }

    setProducts(sortedProducts);
  };
  // Infinite scroll logic
  const lastProductRef = useCallback(
    (node) => {
      if (!node) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (
          entries[0].isIntersecting &&
          !isFetchingRef.current &&
          !isFilterActive &&
          products.length < totalProducts
        ) {
          isFetchingRef.current = true;

          fetchProducts(page + 1).finally(() => {
            isFetchingRef.current = false;
          });
        }
      });

      observer.current.observe(node);
    },
    [page, products.length, totalProducts],
  );

  // Filter
  const handleFilterSelect = (group, value) => {
    if (!activeFilterGroup || activeFilterGroup === group) {
      let newSelected = [];
      if (selectedFilters.includes(value)) {
        newSelected = selectedFilters.filter((v) => v !== value); // deselect
      } else {
        newSelected = [...selectedFilters, value]; // select
      }
      setSelectedFilters(newSelected);

      if (newSelected.length === 0) {
        setActiveFilterGroup(null); // reset if nothing selected
      } else {
        setActiveFilterGroup(group);
      }
    } else {
      // switching to a new group
      setActiveFilterGroup(group);
      setSelectedFilters([value]);
    }
  };

  useEffect(() => {
    if (activeFilterGroup && selectedFilters.length > 0) {
      setIsFilterActive(true);
      const params = new URLSearchParams({
        page: 1,
        limit: 20,
      });

      if (activeFilterGroup === "category") {
        params.append("category", selectedFilters.join(","));
      } else if (activeFilterGroup === "brand") {
        params.append("brand", selectedFilters.join(","));
      }

      fetch(`https://udemandme.com/api/products/filter?${params.toString()}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setProducts(data.products);
            setPages(data.pages);
            setPage(1);
          }
        })
        .catch((err) => console.error(err));
    } else if (!activeFilterGroup && !searchQuery) {
      setIsFilterActive(false);
      fetchProducts(1);
    }
  }, [selectedFilters, activeFilterGroup]);

  // Price Request
  const handlePriceRequest = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const form = e.target;

    const payload = {
      name: form.name.value.trim(),
      email: form.email.value.trim(),
      contact: form.contact.value.trim(),
      message: form.message.value.trim(),
      productName: product?.productName,
      productSku: product?.productSku,
      productId: product?._id,
    };

    try {
      // API endpoint can be changed later
      await axios.post("https://udemandme.com/api/pricerqst", payload);

      toast.success("Request submitted successfully");
      form.reset();
      setShowPriceRequestModal(false);
    } catch (err) {
      toast.error("Failed to submit request");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="shop py-80">
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar Start */}
          <div className="col-12  col-lg-3">
            {" "}
            {/* col-12 = mobile full width, col-lg-3 = desktop */}
            <div
              className={`shop-sidebar ${
                active ? "d-block" : "d-none d-lg-block"
              }`}
              style={{
                position: "sticky",
                top: "80px",
                height: "calc(100vh - 80px)",
                overflowY: "auto", // ✅ SIDEBAR SCROLLS
                overflowX: "hidden",
                zIndex: 999,
                backgroundColor: "white",
              }}
            >
              {/* Mobile Close Button */}
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute end-0 me-3 mt-3 hover-text-white hover-border-main-600"
              >
                <i className="ph ph-x" />
              </button>

              {/* Sidebar Content */}
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Product Category
                </h6>
                <input
                  type="text"
                  placeholder="Search category..."
                  value={categorySearch}
                  onChange={(e) => setCategorySearch(e.target.value)}
                  className="form-control common-input mb-20"
                />
                <div
                  className="filter-list-wrapper"
                  style={{
                    maxHeight: "220px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <ul className="scroll-sm">
                    {(isSearchingCategory
                      ? searchedCategories
                      : categories
                    ).map((cat, index, arr) => (
                      <li key={cat._id} className="mb-24">
                        <div className="form-check common-check">
                          <input
                            type="checkbox"
                            id={`category-${cat._id}`}
                            className="form-check-input"
                            checked={
                              activeFilterGroup === "category" &&
                              selectedFilters.includes(cat.name)
                            }
                            disabled={
                              activeFilterGroup &&
                              activeFilterGroup !== "category"
                            }
                            onChange={() =>
                              handleFilterSelect("category", cat.name)
                            }
                          />
                          <label
                            htmlFor={`category-${cat._id}`}
                            className="form-check-label text-gray-900 hover-text-main-600"
                          >
                            {formatCategoryName(cat.name)}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Brand Content */}
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Product Brands
                </h6>

                <input
                  type="text"
                  placeholder="Search brand..."
                  value={brandSearch}
                  onChange={(e) => setBrandSearch(e.target.value)}
                  className="form-control common-input mb-20"
                />
                <div
                  className="filter-list-wrapper"
                  style={{
                    maxHeight: "220px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <ul className="scroll-sm">
                    {(isSearchingBrand ? searchedBrands : brands).map(
                      (brand) => {
                        const brandId = `brand-${brand._id}`;

                        return (
                          <li key={brand._id} className="mb-24">
                            <div className="form-check common-check">
                              <input
                                type="checkbox"
                                id={brandId} // ✅ ADD ID
                                className="form-check-input"
                                checked={
                                  activeFilterGroup === "brand" &&
                                  selectedFilters.includes(brand.name)
                                }
                                disabled={
                                  activeFilterGroup &&
                                  activeFilterGroup !== "brand"
                                }
                                onChange={() =>
                                  handleFilterSelect("brand", brand.name)
                                }
                              />
                              <label
                                htmlFor={brandId} // ✅ LINK LABEL
                                className="form-check-label text-gray-900 hover-text-main-600"
                                style={{ cursor: "pointer" }} // optional UX polish
                              >
                                {brand.name}
                              </label>
                            </div>
                          </li>
                        );
                      },
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Sidebar End */}

          {/* Content Start */}
          <div className="col-lg-9">
            {/* Top Start */}
            <div className="flex-between gap-16 flex-wrap mb-40 ">
              <span className="text-gray-900">
                {/* Showing {products.length} of {totalProducts} results */}
              </span>
              <div className="position-relative flex-align gap-16 flex-wrap">
                <div className="list-grid-btns flex-align gap-16">
                  <button
                    onClick={() => setGrid(true)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                      grid === true && "border-main-600 text-white bg-main-600"
                    }`}
                  >
                    <i className="ph-bold ph-list-dashes" />
                  </button>
                  <button
                    onClick={() => setGrid(false)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                      grid === false && "border-main-600 text-white bg-main-600"
                    }`}
                  >
                    <i className="ph ph-squares-four" />
                  </button>
                </div>
                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                  <select
                    value={sortOption}
                    onChange={handleSort}
                    className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                    id="sorting"
                  >
                    {/* <option value="default">Sort By Price</option> */}
                    <option value="low">Low to High</option>
                    <option value="high">High to Low</option>
                  </select>
                </div>
                <button
                  onClick={sidebarController}
                  type="button"
                  className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                >
                  <i className="ph-bold ph-funnel" />
                </button>
              </div>
            </div>
            {/* Top End */}
            <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              {products.map((product) => (
                <div
                  key={product.id}
                  className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2"
                >
                  <Link
                    to={`/product-details/${product.productSlug}`}
                    state={{ id: product._id }}
                    className="product-card__thumb flex-center rounded-8 position-relative"
                  >
                    <img
                      src={
                        product.productMainImage
                          ? product.productMainImage.startsWith("http")
                            ? product.productMainImage
                            : `https://udemandme.cloud/backend${product.productMainImage}`
                          : "assets/images/thumbs/productu.png"
                      }
                      alt={product.productName}
                      className="w-auto"
                    />

                    {new Date(product.createdAt) >
                      new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) && (
                      <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                        New
                      </span>
                    )}
                  </Link>

                  <div
                    style={{ marginTop: "8px" }}
                    className="product-card__content mt-16"
                  >
                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                      <Link
                        to={`/product-details/${product.productSlug}`}
                        state={{ id: product._id }}
                        className="link text-line-2"
                        tabIndex={0}
                      >
                        {product.productName}
                      </Link>
                    </h6>

                    {/* ✅ Stock Status */}
                    {/* <div className="mt-8">
                      <div
                        className="progress w-100 bg-color-three rounded-pill h-4"
                        role="progressbar"
                        aria-label="Stock"
                        aria-valuenow={product.productStock}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className={`progress-bar rounded-pill ${
                            product.productStock > 0
                              ? "bg-success"
                              : "bg-danger"
                          }`}
                          style={{
                            width: `${Math.min(product.productStock, 100)}%`,
                          }}
                        />
                      </div>

                      <span
                        className={`text-xs fw-medium mt-8 d-block ${
                          product.productStock > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {product.productStock > 0 ? "In Stock" : "Out of Stock"}
                      </span>
                    </div> */}
                    <span className="text-sm h6 primecolor">
                      {product?.productCategories
                        ?.slice(0, 2)
                        .map((cat) => cat.name)
                        .join(", ")}
                    </span>

                    <div className="product-card__price mb-12">
                      {product?.priceOnRequest === 1 ? (
                        <span className="text-heading text-md fw-semibold">
                          Price on Request
                        </span>
                      ) : (
                        <>
                          <span
                            className="text-gray-400 text-md fw-semibold text-decoration-line-through"
                            style={{ marginRight: "10px" }}
                          >
                            AED {product.productRegularPriceInr}
                          </span>
                          <span className="text-heading text-md fw-semibold ml-2">
                            AED {product.productSalePriceInr}
                          </span>
                        </>
                      )}
                    </div>

                    <div className="custom-flex-wrapper">
                      {product?.priceOnRequest === 1 ? (
                        <button
                          type="button"
                          onClick={() => {
                            setProduct(product);
                            setShowPriceRequestModal(true);
                          }}
                          className="product-card__cart btn bg-btn-primecolor text-light hover-text-white py-11 rounded-8 flex-center gap-8 fw-medium"
                        >
                          Price on Request
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            if (!product?._id) {
                              toast.error("Product not available");
                              return;
                            }

                            const payload = product?.productSalePriceInr
                              ? {
                                  attributeName: null,
                                  attributeValue: null,
                                  attributeId: null,
                                  attributeSalePriceInr:
                                    product.productSalePriceInr,
                                  attributeRegularPriceInr:
                                    product.productRegularPriceInr,
                                  attributeSalePriceUsd:
                                    product.productSalePriceUsd,
                                  attributeRegularPriceUsd:
                                    product.productRegularPriceUsd,
                                }
                              : null;

                            addToCart(product, 1, payload);
                          }}
                          className="product-card__cart btn bg-btn-primecolor text-light hover-text-white py-11 rounded-8 flex-center gap-8 fw-medium"
                        >
                          Add To Cart <i className="ph ph-shopping-cart" />
                        </button>
                      )}

                      <Link
                        to="#"
                        onClick={() => {
                          const productUrl = `${window.location.origin}/product-details/${product.productSlug}`;
                          const message = `Check out this product: ${product.productName}\n${productUrl}`;

                          // WhatsApp link for a specific number
                          const whatsappUrl = `https://wa.me/971502530888?text=${encodeURIComponent(
                            message,
                          )}`;
                          window.open(whatsappUrl, "_blank");
                        }}
                        className="product-card__cart btn bg-success-btn text-light hover-text-white flex-center fw-medium"
                        style={{
                          width: "50px", // 👈 same width
                          height: "50px", // 👈 same height
                          borderRadius: "50%", // 👈 makes it circular
                          padding: "0", // 👈 optional: centers content
                          marginLeft: "15px",
                        }}
                      >
                        <i className="ph ph-whatsapp-logo"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination Start */}
            <div ref={lastProductRef} style={{ height: "1px" }} />
            {loading && <p>Loading...</p>}
            {/* Pagination End */}
          </div>
          {/* Content End */}
        </div>
      </div>
      {/* Modal Price */}
      {showPriceRequestModal && (
        <>
          <div
            className="modal fade show"
            style={{ display: "block", zIndex: 1055 }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content rounded-16">
                <div className="modal-header">
                  <h5 className="modal-title">Price on Request</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowPriceRequestModal(false)}
                  />
                </div>

                <form onSubmit={handlePriceRequest}>
                  <div className="modal-body">
                    <div className="row g-3">
                      {/* Name */}
                      <div className="col-md-6">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          name="name"
                          className="common-input rounded-8"
                          required
                        />
                      </div>

                      {/* Email */}
                      <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="common-input rounded-8"
                          required
                        />
                      </div>

                      {/* Contact */}
                      <div className="col-md-6">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="text"
                          name="contact"
                          className="common-input rounded-8"
                          required
                        />
                      </div>

                      {/* Product Name */}
                      <div className="col-md-6">
                        <label className="form-label">Product Name</label>
                        <input
                          type="text"
                          className="common-input rounded-8"
                          value={product?.productName || ""}
                        />
                      </div>

                      {/* Product SKU */}
                      <div className="col-md-12">
                        <label className="form-label">Product SKU</label>
                        <input
                          type="text"
                          className="common-input rounded-8"
                          value={product?.productSku || ""}
                        />
                      </div>

                      {/* Message */}
                      <div className="col-12">
                        <label className="form-label">Message</label>
                        <textarea
                          name="message"
                          className="common-input rounded-8"
                          rows="4"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary rounded-pill"
                      onClick={() => setShowPriceRequestModal(false)}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn btn-main rounded-pill"
                      disabled={submitting}
                    >
                      {submitting ? "Submitting..." : "Submit Request"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1050, pointerEvents: "none" }}
          />
        </>
      )}
    </section>
  );
};

export default ShopSection;
